import { render, staticRenderFns } from "./OpdrachtItemNieuw.vue?vue&type=template&id=2ce62dba&scoped=true&"
import script from "./OpdrachtItemNieuw.vue?vue&type=script&lang=js&"
export * from "./OpdrachtItemNieuw.vue?vue&type=script&lang=js&"
import style0 from "./OpdrachtItemNieuw.vue?vue&type=style&index=0&id=2ce62dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce62dba",
  null
  
)

export default component.exports